import React from 'react';
import Tooltip from '@mui/material/Tooltip';

class CUSTOM_TAG_EXTRACTOR {

    static SPLIT_DEFINITION_ELEMENTS_FROM_STRING(string, definitions, layerKey){

        let definitionElements = string.match(/<a href='#' data-local-definition-key.*?<\/a>/g)

        if(definitionElements){

            definitionElements = definitionElements.map((definition) => {

                let definitionKey = definition.match(/(data-local-definition-key='([^']+)')/g)[0].split("'")[1]
                let definitionCopy = definitions[layerKey]["definitions"][definitionKey].description

                return({
                    label:definition.replace(/(<([^>]+)>)/gi, ""),
                    toolTip:definitionCopy
                });
            })

        }

        return {
            definitionElemments:definitionElements,
            copyItems:string.split(/<a href='#' data-local-definition-key.*?<\/a>/g)
        }
    }

    static GENERATE_INLINE_TOOL_TIP_PARAGRAPH(definitionElements, copyParts){

        let newCopyParts = [];

        let insertedToolTips = 0;

        copyParts.forEach((copy, index) => {
            let insertIndex = index + insertedToolTips;
            if(copy === "" && index === 0){
                newCopyParts[insertIndex] = "TOOL TIP HERE";
            }else if(copyParts.length-1 === index && copy === ""){
                newCopyParts[insertIndex] = "TOOL TIP HERE";
            }else{
                newCopyParts[insertIndex] = copy;
                if(copyParts[index+1] !== "" && copyParts.length-1 !== index && copyParts[index+1] !== undefined){
                    newCopyParts.push("TOOL TIP HERE")
                    insertedToolTips++
                }
            }
        })

        let definitionIndex = 0
        
        let paragraphMarkup = newCopyParts.map((string, index) => {

            let definitionItem =

                string === 'TOOL TIP HERE'
                ?

                    <Tooltip key={index} title={
                        <span dangerouslySetInnerHTML={{__html:definitionElements[definitionIndex].toolTip}}>
                        </span>
                        }>
                        <a href={`#${index}`}>{definitionElements[definitionIndex].label}</a>
                    </Tooltip>

                :
                    <span key={index} dangerouslySetInnerHTML={{__html:string}}/>



            if(string === 'TOOL TIP HERE'){
                definitionIndex++
            }

            return (definitionItem)
        })

        return paragraphMarkup

    }

}
export default CUSTOM_TAG_EXTRACTOR;